import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const individualDeersUrl = `${SERVER_API}/ttp-registries/individual-deers`;
